import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { searchProduct } from "../../store/actions/product";
// import { css } from "aphrodite-jss";
import { Link } from "react-router-dom";
import style from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import Cart from "./Cart";
import Search from "./Search";
import Navigation from "./Navigation";
import UserMenu from "./UserMenu";
import { Helmet } from "react-helmet";

class Header extends Component {
  renderMetaHeader() {
    let title = this.props.setting.setting && this.props.setting.setting.title;
    let description =
      this.props.setting.setting && this.props.setting.setting.description;
    let keywords =
      this.props.setting.setting && this.props.setting.setting.keywords;
    let og_type = null; //"article"
    let og_title = null;
    let og_image = null;
    let og_url = null;

    const { pathname } = this.props.router.location;
    if (pathname === "/") {
    } else if (pathname.indexOf("/p/") >= 0) {
      const aar = pathname.split("/");
      const slugP = aar[aar.length - 1];
      const page = this.props.page.page.find(({ slug }) => slug === slugP);
      title = `${page.menu_title} - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/sifremi-unuttum") {
      title = `Şifremi Unuttum - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/reset-password") >= 0) {
      title = `Şifremi Sfıırla - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/giris-yap") {
      title = `Giriş Yap - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/uye-ol") {
      title = `Üye Ol - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim") {
      title = `Hesabım - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparislerim") {
      title = `Siparişlerim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparis-gecmisim") {
      title = `Sipariş Geçmişim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparis/detay") {
      title = `Sipariş Detayları - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/profilimi-duzenle") {
      title = `Profilimi Düzenle - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/adreslerim") {
      title = `Adreslerim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/sifremi-guncelle") {
      title = `Şifremi Güncelle - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/kategori/") >= 0) {
      title = `${
        this.props.category.category && this.props.category.category.title
      } - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/urun/") >= 0) {
      if (this.props.product.product) {
        title = `${this.props.product.product.name} - ${this.props.setting.setting.title}`;
        if (this.props.product.product.meta_description !== "") {
          description = this.props.product.product.meta_description;
        }
        if (this.props.product.product.meta_keywords !== "") {
          keywords = this.props.product.product.meta_keywords;
        }
        og_type = "article";
        og_title = this.props.product.product.title;
        og_image = PUBLIC_URL(this.props.product.product.image);
        og_url = window.location;
      }
    } else if (pathname === "/sepet") {
      title = `Sepetim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/odeme/giris") {
      title = `Ödeme için giriş yapın - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/odeme" || pathname === "/odeme/misafir") {
      title = `Ödeme - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/siparis-basarili") {
      title = `Siparişiniz Başarıyla Alında - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else {
      title = this.props.setting.setting.title;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    }

    const meta = [
      { name: "description", content: description },
      { name: "keywords", content: keywords },
    ];

    og_type && meta.push({ property: "og:type", content: og_type });
    og_title && meta.push({ property: "og:title", content: og_title });
    og_image && meta.push({ property: "og:image", content: og_image });
    og_url && meta.push({ property: "og:url", content: og_url });

    return <Helmet title={title} meta={meta} />;
  }

  render() {
    return (
      <React.Fragment>
        <div className="row" style={{ backgroundColor: "#f4f5f6" }}>
          <div className="col-md-12">
            <div style={{ padding: "6px 0 7px" }}>
              <div className="container">
                <div className="row">
                  <div className={`col-md-4 text-left m-center`}>
                    <a
                      href={`tel:${
                        this.props.setting.setting &&
                        this.props.setting.setting.phone
                      }`}
                      className={style.headerTop}
                    >
                      <FontAwesomeIcon icon={["fas", "phone"]} /> Sipariş Hattı:
                      <span>
                        {this.props.setting.setting &&
                          this.props.setting.setting.phone}
                      </span>
                    </a>
                  </div>

                  <div
                    className={"col-md-8 text-right m-flex-jc-center"}
                    style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "20px" }}
                  >
                    <UserMenu />
                    
                    <Link to={"/siparis-sorgula"} className={style.headerTop}>
                      <FontAwesomeIcon icon={["fas", "search"]} />
                      <span className="desktop-only" style={{ marginLeft: "5px" }}>Sipariş Sorgula</span>
                    </Link>

                    <ul className={`m-hidden ${style.headerTopSocialUL}`}>
                      {this.props.setting.setting &&
                        this.props.setting.setting.facebook !== "" && (
                          <li>
                            <a
                              target="_blank"
                              href={
                                this.props.setting.setting &&
                                this.props.setting.setting.facebook
                              }
                              className={"facebook"}
                            >
                              <FontAwesomeIcon icon={["fab", "facebook"]} />
                            </a>
                          </li>
                        )}
                      {this.props.setting.setting &&
                        this.props.setting.setting.instagram !== "" && (
                          <li>
                            <a
                              target="_blank"
                              href={
                                this.props.setting.setting &&
                                this.props.setting.setting.instagram
                              }
                              className={"instagram"}
                            >
                              <FontAwesomeIcon icon={["fab", "instagram"]} />
                            </a>
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            {this.renderMetaHeader()}
            {/* <div style={{ backgroundColor: "#f4f5f6", padding: "6px 0 7px" }}>
            <div className="container">
              <div className="row">
                <div className={`col-md-6 text-left m-center`}>
                  <a
                    href={`tel:${
                      this.props.setting.setting &&
                      this.props.setting.setting.phone
                    }`}
                    className={style.headerTop}
                  >
                    <FontAwesomeIcon icon={["fas", "phone"]} /> Sipariş Hattı:
                    <span>
                      {this.props.setting.setting &&
                        this.props.setting.setting.phone}
                    </span>
                  </a>
                </div>

                <div
                  className={"col-md-6 text-right m-flex-jc-center"}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <ul
                    className={`${style.headerTop} ${style.headerTopRightUL}`}
                  >
                    {this.props.customer.customer && (
                      <React.Fragment>
                        <li>
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            Hoş geldin{" "}
                            <strong>
                              {this.props.customer.customer.full_name}
                            </strong>
                            !
                          </a>
                        </li>
                        <li>
                          <Link to="/hesabim">
                            <span>
                              <FontAwesomeIcon icon={["fas", "user-circle"]} />
                            </span>{" "}
                            Hesabım
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"/cikis-yap"}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.logOut();
                            }}
                          >
                            <span>
                              <FontAwesomeIcon icon={["fas", "power-off"]} />
                            </span>{" "}
                            Çıkış Yap
                          </Link>
                        </li>
                      </React.Fragment>
                    )}
                    {!this.props.customer.customer && (
                      <React.Fragment>
                        <li>
                          <Link to={"/giris-yap"}>
                            <span>
                              <FontAwesomeIcon icon={["fas", "sign-in-alt"]} />
                            </span>{" "}
                            Giriş Yap
                          </Link>
                        </li>
                        <li>
                          <Link to={"/uye-ol"}>
                            <span>
                              <FontAwesomeIcon icon={["fas", "user-plus"]} />
                            </span>{" "}
                            Kayıt Ol
                          </Link>
                        </li>
                      </React.Fragment>
                    )}
                  </ul>
                  <ul className={`m-hidden ${style.headerTopSocialUL}`}>
                    {this.props.setting.setting &&
                      this.props.setting.setting.facebook !== "" && (
                        <li>
                          <a
                            target="_blank"
                            href={
                              this.props.setting.setting &&
                              this.props.setting.setting.facebook
                            }
                            className={"facebook"}
                          >
                            <FontAwesomeIcon icon={["fab", "facebook"]} />
                          </a>
                        </li>
                      )}
                    {this.props.setting.setting &&
                      this.props.setting.setting.instagram !== "" && (
                        <li>
                          <a
                            target="_blank"
                            href={
                              this.props.setting.setting &&
                              this.props.setting.setting.instagram
                            }
                            className={"instagram"}
                          >
                            <FontAwesomeIcon icon={["fab", "instagram"]} />
                          </a>
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            </div>
          </div> */}

            <div>
              <div className={`${style.header}`}>
                <div className="container">
                  <div className="row">
                    <div className={"col-md-3 m-center"}>
                      <Link to={"/"}>
                        <img
                          alt={
                            this.props.setting.setting &&
                            this.props.setting.setting.title
                          }
                          src={PUBLIC_URL(
                            this.props.setting.setting &&
                              this.props.setting.setting.logo
                          )}
                          className={style.logo}
                          height={60}
                          style={{ marginLeft: 10 }}
                        />
                      </Link>
                    </div>

                    <div className="col-md-6  m-auto">
                      <Search />
                    </div>
                    <div className={"col-md-3 text-right m-center"}>
                      <Cart />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Navigation />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  router,
  customer,
  setting,
  page,
  category,
  product,
}) => {
  return {
    router,
    customer,
    setting,
    page,
    category,
    product,
  };
};

const mapDispatchToProps = { logOut, searchProduct };

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/shared/Header.js